import { FuelTypeEntity, FuelField } from '../types';

export const getFuelTypeFields = (
  fuelTypeId: string | undefined,
  fuelTypes: FuelTypeEntity[]
): FuelField[] =>
  fuelTypes.find(f => f.id === Number(fuelTypeId))?.dependent_fields ?? ['engine_volume'];

export const filterParts = (parts: string[]): string[] => parts.filter(Boolean);

export const joinParts = (parts: string[], separator = ', '): string =>
  filterParts(parts).join(separator);
